import { render } from "./DedicatedVLANTab.vue?vue&type=template&id=f6c093dc&scoped=true"
import script from "./DedicatedVLANTab.vue?vue&type=script&lang=js"
export * from "./DedicatedVLANTab.vue?vue&type=script&lang=js"

import "./DedicatedVLANTab.vue?vue&type=style&index=0&id=f6c093dc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c093dc"]])

export default __exports__